module.exports = __webpack_public_path__ + "static/turtle-creek-house41-a9f51d957ca51707e694a5b132eb8e55.jpg";